import React from "react";
import FixedDecimalTextField from "../components/FixedDecimalTextField";

const ColumnRate = ({ params, item, handleRowUpdate, disableRate, rowError }) => {
  const fieldName = item?.sColumnID;

  const fieldId =
    params?.row?._fieldIds?.[fieldName] ||
    item?.inputType?.component?.sName;

  const updateValue = value => {
    handleRowUpdate({
      fieldName,
      value,
      rowId: params?.row?.id,
    });
  };

  return (
    <FixedDecimalTextField
      component={item?.inputType?.component}
      value={
        params?.row?.[fieldName] ??
        item?.inputType?.component?.sDefaultValue ??
        "0"
      }
      onValueChange={updateValue}
      placeholder={item?.inputType?.component?.sPlaceHolder}
      id={`${fieldId}-${params?.row?.id}`}
      disabled={disableRate}
      error={!!rowError}
      helperText={rowError || ""}
    />
  );
};

export default ColumnRate;
